import React, { useMemo } from 'react';
import { DocumentCategoryQueryData } from '@area-restrita/api-client/model/documentCategoryQueryData';
import { useGetDocumentCategoriesInfinite } from '@area-restrita/api-client/endpoints/document-category/document-category.gen';

import Select, { ISelectProps, SelectOption } from '../Select';

const toComboboxOption = (
  company: DocumentCategoryQueryData,
): SelectOption => ({
  label: company.description,
  value: company.id,
});

type IProps = Omit<ISelectProps, 'options'> & {
  allowsChangeRequest?: boolean;
};

const DocumentCategorySelector = React.forwardRef<HTMLInputElement, IProps>(
  ({ allowsChangeRequest, ...props }, _ref) => {
    const query = useGetDocumentCategoriesInfinite(
      { limit: 100, page: 1, allowsChangeRequest },
      {
        query: {
          queryKeyHashFn: (args) => JSON.stringify(['infinite', ...args]),
          getNextPageParam: (lastPage, _, lastPageParam) =>
            lastPage.data.length > 0 ? lastPageParam + 1 : null,
        },
      },
    );

    const categories = useMemo(
      () =>
        query.data?.pages.flatMap<SelectOption>((page) =>
          page.data.map(toComboboxOption),
        ) ?? [],
      [query.data],
    );

    return (
      <Select
        {...(props as ISelectProps)}
        options={categories}
        placeholder="Selecione uma categoria"
        plural="categorias"
      />
    );
  },
);

export default DocumentCategorySelector;
